<template lang="pug">
  title-tab(
    :msg="$t('title.affiliate')"
    :sub-msg="`${ $t('with') } ${userProfile.username}`"
  )
    template(#buttonAppend)
      v-btn(
        color='var(--bg-secondary-color)' 
        @click='openDialogWithdraw'
      )
        v-img.mr-2(
          width='25'
          src='@/assets/recommend/atm2.svg'
        ) 
        b {{ $t('button.withdraw-income') }}
    template(v-slot:extensionBottom)
      v-tabs(
        v-model='currentItem'
        background-color='var(--bg-main-color)'
      )
        v-tab(
          v-for='item in headers'
          :key='item'
          @click="GA('SelectTab',item)"
        )
          h4 {{ $t(item) }}  
    n-tap-01(ref='overall' v-if='currentItem===0') 
    n-tap-02(v-else-if='currentItem===1') 
    n-tap-03(v-else-if='currentItem===2')
    dialog-withdraw(
      ref='dialogwithdraw' 
      @success='fetchOverall'
    )

</template>
<script>   
import NTap01 from './childs/P01Overall'
import NTap02 from './childs/P02Member'
import NTap03 from './childs/P03Profit' 
import dialogWithdraw from './childs/dialogWithdraw'

export default {
  components:{
    NTap01,
    NTap02,
    NTap03, 
    dialogWithdraw
  },
  data: () => ({
    currentItem: 0,
    headers:['tab.over-view','tab.member','tab.income'],
  }),
  computed:{
    overAll () {
      return this.$store.getters['affiliate/GETTERS_OVERALL']
    },
    wallet () {
      return this.$store.getters['userProfile/GETTERS_WALLET']
    },
    userProfile () {
      return this.$store.getters['userProfile/GETTERS_ME']
    },
  },  

  methods:{
    fetchOverall () {
      if(this.currentItem===0){ 
        this.$refs.overall.getOverAll()
      } 
    }, 
    GA (actions,value) {
      this.$ga.event('Button', actions, 'AffiliatePage',value )
    },  
    openDialogWithdraw () {
      this.GA('OpenDialogWithdraw','')
      this.$refs.dialogwithdraw.open(this.overAll.commission_exchange_remain)
    }
  }  
}
    

</script> 